import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check local storage for existing token/user data on mount
    const storedUser = localStorage.getItem('linyuan_user');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Failed to parse stored user data", e);
        localStorage.removeItem('linyuan_user');
      }
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('linyuan_user', JSON.stringify(userData));
    if (userData.token) {
        localStorage.setItem('linyuan_token', userData.token);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('linyuan_user');
    localStorage.removeItem('linyuan_token');
  };

  const updateUser = (updates) => {
      setUser(prev => {
          const newUser = { ...prev, ...updates };
          localStorage.setItem('linyuan_user', JSON.stringify(newUser));
          return newUser;
      });
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
